export default __webpack_public_path__ + "static/media/kjibiki.642fdf02.png";